<template>
  <div>
    <!-- 累计里程 -->
    <Title :title="'累计换电里程'"></Title>
    <Chart :cdata="cdata" :height="height" :width="width" />
  </div>
</template>

<script>
import Chart from '../gauge.vue'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
        height:'230',
        width:'500',
        cdata:{
            id:"battery",
            data:[
                {
                  name:"维修次数",
                  value: 0
                }
            ]
        },
    };
  },
  components: {
    Chart,
    Title
  },
  watch: {

  },
  // props:{
  //   peratingMileage:{
  //     type: Number,
  //     default: () => ('')
  //   },
  // },
  mounted () {
  },
  methods: {
    getData(data){
      this.getPeratingMileage(data);
    },
    getPeratingMileage(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-leijilicheng',
          '@station_id':data.stationId,
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          console.log("累计",res);
          _this.cdata.data[0].value = res&&res[0]&&res[0].odo;
          
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }

}
</script>